import React, { useEffect, useState } from "react";

const HospitalDoctors = () => {
    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-docsettinghold tab-pane active fade show" id="dc-security">
                <div className="dc-docsettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle dc-titlewithicon">
                        <h3>Saved Doctors</h3>
                        <a href="javascript:;" data-post-id="18128" data-itme-type="_saved_doctors" className="dc-clicksave dc-clickremoveall">
                            <i className="lnr lnr-cross"></i>
                            Remove all saved doctors
                        </a>
                    </div>
                    <div className="dc-docsettingscontent dc-sidepadding">
                        <div className="dc-searchresult-grid dc-searchresult-list dc-searchvlistvtwo">
                            <div className="dc-docpostholder">
                                <div className="dc-docpostcontent">
                                    <div className="dc-searchvtwo">
                                        <figure className="dc-docpostimg">
                                            <img width="" height="" className="dc-image-res" src="//css.meddylist.com//wp-content/uploads/2025/04/google_map_6801f08b8280d-1-100x100.jpg" alt="Shaik Azeemuddin" />
                                            <img width="" height="" className="dc-image-res-2x" src="//css.meddylist.com//wp-content/uploads/2025/04/google_map_6801f08b8280d-1.jpg" alt="Shaik Azeemuddin" />
                                            <figcaption>
                                                <span className="dc-featuredtag"><i className="fa fa-bolt"></i></span>
                                            </figcaption>
                                        </figure>
                                        <div className="dc-title">
                                            <h3>
                                                <a href="//css.meddylist.com//doctors/shaik-azeemuddin/">Shaik Azeemuddin</a>
                                                <i className="far fa-check-circle dc-awardtooltip dc-tipso tipso_style" data-tipso="Verified user"></i>
                                            </h3>
                                            <ul className="dc-docinfo">
                                                <li><em>Consultant Orthopedic Surgeon</em></li>
                                                <li>
                                                    <span className="dc-stars"><span style={{ width: "0%" }}></span></span>
                                                    <em>0&nbsp;Feedback</em>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="dc-actions">
                                    <a href="#" data-id="18128" data-itme-type="_saved_doctors" data-item-id="19494" className="dc-removesingle_saved">
                                        <span className="lnr lnr-trash"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HospitalDoctors;
